document.querySelectorAll(".accordion-title").forEach((item) => {
    item.addEventListener("click", function () {
        const content = this.nextElementSibling;
        const arrowIcon = this.querySelector(".arrow_icon"); // `button` 内の `arrow_icon` を取得

        // すべてのアコーディオンを閉じ、矢印の `active` をリセット
        document.querySelectorAll(".accordion-content").forEach((el) => {
            if (el !== content) {
                el.style.maxHeight = null;
                el.previousElementSibling.querySelector(".arrow_icon").classList.remove("active");
            }
        });

        // クリックされた要素の開閉
        if (content.style.maxHeight) {
            content.style.maxHeight = null;
            arrowIcon.classList.remove("active");
        } else {
            content.style.maxHeight = content.scrollHeight + "px";
            arrowIcon.classList.add("active");
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const selectTrigger = document.querySelector(".select-trigger");
    const selectOptions = document.querySelector(".select-options");

    // ▼▼ 追加：このプルダウンが無いページ（トップ・商品ページ等）では何もしない ▼▼
    if (!selectTrigger || !selectOptions) return;
    // ▲▲ ここまで追加 ▲▲

     // 現在のURLからカテゴリ部分を取得
    function getCategoryFromURL() {
        const urlParts = window.location.pathname.split("/").filter(Boolean);
        const lastPart = urlParts[urlParts.length - 1] || "";
        return decodeURIComponent(lastPart);
    }

    // 取得したカテゴリ名を「カテゴリ」部分に反映
    function updateCategoryText() {
        const categoryName = getCategoryFromURL();
        if (categoryName && categoryName.startsWith("tag-")) {
            const formattedCategory = categoryName.replace("tag-", "").replace(/-/g, " ");
            selectTrigger.childNodes[0].nodeValue = formattedCategory + " ";
        }
    }

    updateCategoryText();

    selectTrigger.addEventListener("click", function () {
        selectOptions.style.display = selectOptions.style.display === "block" ? "none" : "block";
    });

    document.querySelectorAll(".select-options li").forEach((item) => {
        item.addEventListener("click", function () {
            const url = this.getAttribute("data-url");
            if (url) {
                window.location.href = url;
            }
        });
    });

    document.addEventListener("click", function (event) {
        if (!selectTrigger.contains(event.target) && !selectOptions.contains(event.target)) {
            selectOptions.style.display = "none";
        }
    });

});

window.addEventListener('load', function() {
  var pathName = window.location.pathname;
  var englishElements = document.querySelectorAll('.english');
  var japaneseElements = document.querySelectorAll('.japanese');
  var bn_englishElements = document.querySelectorAll('.banner_english');
  var bn_japaneseElements = document.querySelectorAll('.banner_japanese');

  if (pathName.indexOf("/en") > -1) {
    englishElements.forEach(function(element) {
      element.classList.add('lang_active');
    });
    bn_englishElements.forEach(function(element) {
      element.classList.remove('hidden'); // 表示
    });
    japaneseElements.forEach(function(element) {
      element.classList.remove('lang_active');
    });
    bn_japaneseElements.forEach(function(element) {
      element.classList.add('hidden'); // 非表示
    });
  } else {
    japaneseElements.forEach(function(element) {
      element.classList.add('lang_active');
    });
    bn_japaneseElements.forEach(function(element) {
      element.classList.remove('hidden'); // 表示
    });
    englishElements.forEach(function(element) {
      element.classList.remove('lang_active');
    });
    bn_englishElements.forEach(function(element) {
      element.classList.add('hidden'); // 非表示
    });
  }
});